<template>
  <div
    class="ms-textarea ms-editor"
    :class="{
      //error: errorProvider.isValid
      disabled: disabled,
    }"
  >
    <div
      class="flex-row border"
      :class="{
        error: errorProvider.isValid,
        disabled: disabled,
        hasLabel: label,
      }"
    >
      <textarea
        class="ms-textarea-item flex scroller"
        :placeholder="placeholder"
        v-model="internalText"
        :disabled="disabled"
        ref="input"
        v-on="listeners"
        :maxlength="maxLength"
        :rows="rows"
        :readonly="readOnly"
      />
      <label class="input-label z-10" v-if="label"
        >{{ label }} <span v-if="required && isShowRequired" style="color: red">*</span></label
      >

      <div class="icon24 error-icon" v-if="errorProvider.isValid"></div>
    </div>
    <div class="error-text" v-if="errorProvider.isValid">
      {{ errorProvider.message }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from "@/components/msbase/msBaseComponent.vue";
export default {
  extends: msBaseComponent,
  name: "MsTextarea",
  props: {
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    value: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    required: {
      default: false,
      type: Boolean,
    },
    isShowRequired: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    //class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },

    // chỉ đọc không cho nhập
    readOnly: {
      default: false,
      type: Boolean,
    },
    //ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
    label: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      internalText: this.value,
      focused: false,
    };
  },
  computed: {
    listeners() {
      return {
        blur: (e) => {
          this.validate(this.internalText);
          this.onBlur(e);
        },
        focus: (e) => {
          this.onFocus(e);
        },
        change: (e) => {
          this.$emit("change", this.internalText, e);
        },
      };
    },
  },
  methods: {
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    //Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.validate(newVal);
        me.$emit("input", newVal);
      },
    },
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/msTextarea.scss";
$trans-time: 300ms;
.input-label {
  color: #666666;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 13px;
  transition: $trans-time ease all;
  top: 0;
}
.hasLabel {
  position: relative;
  padding: 20px 0 0px 0px;
}
</style>
